import React, { Component } from 'react';
import Slider from "react-slick";

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';


class Products extends Component {
	render() {
		var settings = {
            slidesToScroll: 1,
            autoplay: true,
            arrows: false,
            dots: false,
            autoplaySpeed: 2000,
            responsive: [
                {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1.05,
                    dots: false
                    }
                }
            ]
		};
		return (
			<div>
				<section className="product" id="product-1">
					<div className="product__sidebar">
						<div className="product__image">
							<Slider {...settings}>
								<div className="product__image--single">
									<img className="img-fluid left" src="/images/product-image-1.png" alt="" />
								</div>
								<div className="product__image--single">
									<img className="img-fluid left" src="/images/daynightset.png" alt="" />
								</div>
								<div className="product__image--single">
									<img className="img-fluid left" src="/images/product-image-2.png" alt="" />
								</div>
							</Slider>
						</div>
					</div>
					<div className="product__sidebar product__content">
						<div className="d-md-block d-none">
							<div className="pl-md-3 pl-lg-5 pr-md-3 pr-lg-5">
								<h1 className="product__title">
									Clean Slate <i> Exfoliating Pads</i>
								</h1>
								<h4 className="product__subtitle">For skin as soft as a baby’s bum</h4>
								<p className="product__description"><strong>WHAT IS IT?</strong> Exfoliating pads that dissolve dead skin cells and dirt that clogs your pores. An all-in-one step for smooth, radiant skin.</p>
								<p className="product__description mb-0"><strong>BENIFITS:</strong></p>
								<ul>
									<li> <img src="/images/blackheads.svg" alt="" /> Clears blackheads and acne</li>
									<li> <img src="/images/dull.svg" alt="" /> Brightens dull skin</li>
									<li> <img src="/images/skincare.svg" alt="" /> Helps skincare products absorb better</li>
								</ul>
								<p className="product__description mb-0"><strong>WHY IS IT UNIQUE?</strong></p>
								<ul className="mb-4">
									<li> <img src="/images/right-tick.svg" alt="" /> Packed with plant-based active ingredients- BHAs (Salicylic acid), Centella Asiatica (aka Cica flower) extract, Chamomile extract.</li>
									<li> <img src="/images/right-tick.svg" alt="" /> Works for all skin types, sensitive ones too!</li>
								</ul>
								<div className="add-to-cart__quantity">
									<button className="btn btn-primary add-to-cart">Add to cart - $79</button> 
									<div className="quantity">
										<input type="number" min="1" max="9" step="1" value="1" />
									</div>
								</div>
								<div className="product-promo-box">
									<div className="ppb-item">
										<img className="ppb--desktop mw-100" src="/images/clean-beauty.png" alt="" />
										<img className="ppb--mobile mw-100" src="/images/clean-beauty11.svg" alt="" />
									</div>
									<div className="ppb-item">
										<img className="ppb--desktop mw-100" src="/images/cruelty-free.png" alt="" />
										<img className="ppb--mobile mw-100" src="/images/cruelty-free11.svg" alt="" />
									</div>
									<div className="ppb-item">
										<img className="ppb--desktop mw-100" src="/images/environmentally-friendly.png" alt="" />
										<img className="ppb--mobile mw-100" src="/images/environmentally-friendly11.svg" alt="" />
									</div>
								</div>
							</div>
						</div>
						<div className="d-md-none d-block">
							<div className="pl-md-3 pl-lg-5 pr-md-3 pr-lg-5">
								<div className="for__mobile p-3">
									<h1 className="product__title">
										Clean Slate <i> Exfoliating Pads</i>
									</h1>
									<h4 className="product__subtitle">For skin as soft as a baby’s bum</h4>
									<p className="product__description"><strong>WHAT IS IT?</strong> Exfoliating pads that dissolve dead skin cells and dirt that clogs your pores. An all-in-one step for smooth, radiant skin.</p>
									<div className="add-to-cart__quantity">
										<button className="btn btn-primary add-to-cart">Add to cart - $79</button> 
										<div className="quantity">
											<input type="number" min="1" max="9" step="1" value="1" />
										</div>
										<div className="free__ship mt-3">
											<div className="free__ship-txt text-center">
												<p><img className="mr-1" src="/images/ship-truck.svg" /><strong>Free</strong> Shipping</p>
											</div>
											<div className="free__ship-pack text-right">
												<p>Pack of 30</p>
											</div>
										</div>
									</div>
								</div>
								<div className="padding15">
									<div className="product-promo-box">
										<div className="ppb-item">
											<img className="ppb--desktop mw-100" src="/images/clean-beauty.png" alt="" />
											<img className="ppb--mobile mw-100" src="/images/clean-beauty11.svg" alt="" />
										</div>
										<div className="ppb-item">
											<img className="ppb--desktop mw-100" src="/images/cruelty-free.png" alt="" />
											<img className="ppb--mobile mw-100" src="/images/cruelty-free11.svg" alt="" />
										</div>
										<div className="ppb-item">
											<img className="ppb--desktop mw-100" src="/images/environmentally-friendly.png" alt="" />
											<img className="ppb--mobile mw-100" src="/images/environmentally-friendly11.svg" alt="" />
										</div>
									</div>
									<p className="product__description mb-0"><strong>BENIFITS:</strong></p>
									<ul>
										<li> <img src="/images/blackheads.svg" alt="" /> Clears blackheads and acne</li>
										<li> <img src="/images/dull.svg" alt="" /> Brightens dull skin</li>
										<li> <img src="/images/skincare.svg" alt="" /> Helps skincare products absorb better</li>
									</ul>
									<p className="product__description mb-0"><strong>WHY IS IT UNIQUE?</strong></p>
									<ul className="mb-4">
										<li> <img src="/images/right-tick.svg" alt="" /> Packed with plant-based active ingredients- BHAs (Salicylic acid), Centella Asiatica (aka Cica flower) extract, Chamomile extract.</li>
										<li> <img src="/images/right-tick.svg" alt="" /> Works for all skin types, sensitive ones too!</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pl-md-3 pl-lg-5 pr-md-3 pr-lg-5">
							<div className="padding15">
								<div className="top__reviews">
									<div className="top__reviews__item">
										<h1 className="top__reviews__item-title">
										Top Rated Reviews
										<span>
											<a href="#">See More</a>
										</span>
										</h1>
										<div className="top__reviews__item-content">
											<div className="top__reviews__item-content-left">
												<div className="stars d-inline-block">
													<i className="fa fa-2x fa-star"></i>
													<i className="fa fa-2x fa-star"></i>
													<i className="fa fa-2x fa-star"></i>
													<i className="fa fa-2x fa-star"></i>
													<i className="fa fa-2x fa-star-o"></i>
												</div>
												<div className="review-content">
													<span className="review-icon">A</span>
													<p>
														<span><b>Amanda</b></span><span><i>Verified Buyer</i></span>
													</p>
												</div>
											</div>
											<div className="top__reviews__item-content-right">
												<p><b>My new HOLY GRAIL!</b><br /> My nose feels so smooth! Why wasn’t I exfoliating before, thank you Yours! This glow makes my day!</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="clearfix"></div>
				</section>
				<section className="product" id="product-2">
					<div className="product__sidebar product__content">
						<div className="pr-sm-3 pr-lg-5 pl-md-3 pl-lg-5">
							<div className="padding15 pt-3 pt-md-0">
								<div className="accordion" id="productsecaccordion">
									<Accordion>
								        <AccordionItem>
											<div className="card">
								                <AccordionItemHeading>
									                <AccordionItemButton>
														<div className="card-header">
															<h2 className="mb-0">
															<button className="btn btn-link collapsed" type="button">Active Ingredients</button>
															</h2>
														</div>
													</AccordionItemButton>
												</AccordionItemHeading>
												<AccordionItemPanel>
													<div className="card-body">
														<div className="row">
															<div className="col-4 text-center">
																<img src="/images/1.png" className="img-fluid" />
															</div>
															<div className="col-8">
																<strong>Centella Asiatica Extract</strong>
																(A.K.A Tiger Grass or Gotu Kola)  <br />
																The ultimate hydrating skin-saviour rich in antioxidants which calm inflammation and boost cell growth.
															</div>
															<div className="col-4 text-center">
																<img src="/images/2.png" className="img-fluid" />
															</div>
															<div className="col-8">
																<strong>English Chamomile Extract</strong>
																The perfect soothing ingredient with antiseptic & anti-bacterial properties that tackles irritation, bacteria and pollutants.
															</div>
															<div className="col-4 text-center">
																<img src="/images/3.png" className="img-fluid" />
															</div>
															<div className="col-8">
																<strong>Green Tea Leaf Extract</strong>
																The all-in-one: it soothes redness and irritations, evens out discoloration, gently exfoliates, eliminates bacteria, and even diminishes signs of aging.
															</div>
															<div className="col-4 text-center">
																<img src="/images/4.png" className="img-fluid" />
															</div>
															<div className="col-8">
																<strong>Arginine</strong>
																An amino acid that protects the skin from free
																radicals and boosts skin hydration and collagen production
															</div>
															<div className="col-4 text-center">
																<img src="/images/5.png" className="img-fluid" />
															</div>
															<div className="col-8">
																<strong>Sodium Hyaluronate</strong>
																A revitalising ingredient to restore skin moisture.
																It smoothes the appearance of wrinkles and
																improves skin
															</div>
															<div className="col-4 text-center">
																<img src="/images/6.png" className="img-fluid" />
															</div>
															<div className="col-8">
																<strong>Salicylic Acid (BHA)</strong>
																An excellent pore-clearing ingredient, it gently exfoliates the surface of the skin and deeply penetrates the pores to remove oil and sebum.
															</div>
															<div class="col-12 mt-4"><strong><u>See Full List of Ingredients</u></strong></div>
														</div>
													</div>
												</AccordionItemPanel>
											</div>
										</AccordionItem>
										<AccordionItem>
											<div className="card">
								                <AccordionItemHeading>
									                <AccordionItemButton>
														<div className="card-header">
															<h2 className="mb-0">
															<button className="btn btn-link collapsed" type="button">How to use</button>
															</h2>
														</div>
													</AccordionItemButton>
												</AccordionItemHeading>
												<AccordionItemPanel>
													<div className="card-body">
														<img className="w-100 mt-4 mb-2" src="/images/video.png" alt="" />
														<ul>
															<li>1. Before bed, cleanse your skin thoroughly and pat dry. </li>
															<li>2. Slip your fingers into the dual-sided Clean Slate pad. Gently work the textured side across your face, neck, chest and shoulders in upwards and outwards motions. </li>
															<li>3. Flip the pad over and repeat to refine and cleanse. Do not rinse off – soak up the goodness of all those active ingredients! </li>
															<li>4. Follow with your toner, personalised serum and moisturiser after fifteen minutes, for the perfect glow. </li>
														</ul>
														<div className="row">
															<div className="col-sm-6">
																<div className="accordion__products">
																	<div className="row">
																		<div className="col-5">
																			<img src="/images/day-cream.png" alt="" />
																		</div>
																		<div className="col-7">
																			<div className="accordion__products--text">
																				<h4>Day Cream</h4>
																				<p>30 ml | $20</p>
																				<button className="btn btn-outline-primary" type="button">Add</button>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
															<div className="col-sm-6">
																<div className="accordion__products">
																	<div className="row">
																		<div className="col-5">
																			<img src="/images/face-serum.png" alt="" />
																		</div>
																		<div className="col-7">
																			<div className="accordion__products--text">
																				<h4>Face Serum</h4>
																				<p>30 ml | $20</p>
																				<button className="btn btn-outline-primary" type="button">Add</button>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
														<p>Warning! Over-exfoliation can lead to irritation, redness and peeling. Make sure to exfoliate just once or twice a week.</p>
													</div>
												</AccordionItemPanel>
											</div>
										</AccordionItem>
										<AccordionItem>
											<div className="card">
								                <AccordionItemHeading>
									                <AccordionItemButton>
														<div className="card-header">
															<h2 className="mb-0">
															<button className="btn btn-link collapsed" type="button">Pro Tips</button>
															</h2>
														</div>
													</AccordionItemButton>
												</AccordionItemHeading>
												<AccordionItemPanel>
													<div className="card-body"><strong>Yours Truly</strong>
													The skincare products from Yours live up to its hype! Thank you for taking extra care of my skin! :)</div>
												</AccordionItemPanel>
											</div>
										</AccordionItem>
									</Accordion>
								</div>
							</div>
						</div>
					</div>
					<div className="product__sidebar">
						<div className="product__image">
							<img className="img-fluid right" src="/images/product-image-2.png" alt="" />
						</div>
					</div>
					<div className="clearfix"></div>
				</section>
			</div>
		);
	}
}


export default Products;